<template>
  <div class="video-player">
    <div
      class="video-container"
      v-for="url in srcs"
      @click="
        src = url
        visible = true
      "
      :key="url"
    >
      <div :class="{ nobg: nobg }">
        <i class="el-icon-video-play"></i>
      </div>
    </div>
    <el-dialog
      :visible.sync="visible"
      width="900px"
      top="10vh"
      @close="
        visible = false
        src = ''
      "
      :close-on-click-modal="false"
      append-to-body
    >
      <video
        id="media"
        :src="src + '?t=' + FileToken"
        controls
        width="100%"
        height="auto"
        style="max-height: 70vh"
        autoplay
      ></video>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    srcs: {
      type: Array,
      default: () => [],
    },
    nobg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      src: '',
    }
  },
}
</script>

<style scoped>
.video-container div.nobg {
  background: none;
}

.video-player {
  display: flex;
}
</style>

<style>
.is-center .video-player {
  justify-content: center;
}
</style>